<template>
  <div>
    <div class="form-container">
      <div class="holder">
        <PaymentForm class="form-horizontal">
          <FormSection title="Payment Amount">
            <FormRow inline>
              <FormCol field="amount" />
            </FormRow>
          </FormSection>
          <FormSection title="Personal Information">
            <FormRow inline>
              <FormCol field="firstName" />
              <FormCol field="lastName" />
            </FormRow>
            <FormRow inline>
              <FormCol field="email" />
              <FormCol field="phone" />
            </FormRow>
            <FormRow inline>
              <Consent privacy="https://www.ou.org/privacy-policy/"/>
            </FormRow>
          </FormSection>
          <FormSection title="Billing Information">
            <DonorAddress />
          </FormSection>
          <FormSection title="Payment Information" last>
            <FormRow inline>
              <FormCol field="card" :showLabel="false" :check_text="checkText"/>
            </FormRow>
          </FormSection>
          <PaymentButton btnText="Submit Payment" showAmount/>
        </PaymentForm>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue'
import { usePaymentForm } from '~/shared/use-payment-form'

export default defineComponent({
  props: {
    checkText: String
  },
  setup() {
    const { form, setValue } = usePaymentForm()

    return {
      form,
      setValue
    }
  }
})
</script>

<style scoped lang="scss">
::v-deep input {
    background: white;
}
</style>